import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { Accordion } from './Accordion';
export function Tomos() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  const tomos = [{
    num: 'Tomo 1',
    title: 'Cimientos',
    icon: '🤲',
    quote: 'Sin base sólida, todo lo que aprendés se olvida en una semana.',
    items: ['Parámetros del LSA: configuración, ubicación, movimiento y expresión', 'Abecedario dactilológico completo con práctica progresiva', 'Números del 1 al 1000 y su uso en contexto', 'Saludos, presentaciones y fórmulas básicas de conversación', 'Los errores más comunes del principiante y cómo evitarlos']
  }, {
    num: 'Tomo 2',
    title: 'Familia y Emociones',
    icon: '👨‍👩‍👧',
    quote: 'Las primeras conversaciones reales siempre arrancan por acá.',
    items: ['Vocabulario completo de familia extendida', 'Las 30 emociones fundamentales con expresión facial correcta', 'Cómo preguntar y responder sobre el estado de ánimo', 'Frases para conversaciones cotidianas con familiares', 'Señas para el tiempo: días, meses, estaciones y clima']
  }, {
    num: 'Tomo 3',
    title: 'Vida Cotidiana',
    icon: '🏠',
    quote: 'El LSA del día a día argentino que ninguna app te va a enseñar.',
    items: ['El hogar: habitaciones, muebles y objetos del hogar', 'Alimentos y comidas típicas argentinas', 'Ropa, colores y descripción de personas', 'La ciudad: transporte, comercios y lugares públicos', 'Rutinas diarias y actividades frecuentes']
  }, {
    num: 'Tomo 4',
    title: 'Mundo Exterior',
    icon: '🌐',
    quote: 'Para cuando el LSA tiene que funcionar fuera de casa.',
    items: ['Vocabulario de trabajo y entorno laboral', 'Salud básica: síntomas, médicos y turnos', 'Tecnología y comunicación digital en señas', 'Trámites: banco, correo, municipio y transporte', 'Tiempo libre, deportes y hobbies']
  }, {
    num: 'Tomo 5',
    title: 'Gramática y Cultura Sorda',
    icon: '📖',
    quote: 'Saber señas no es lo mismo que hablar LSA. Este tomo marca la diferencia.',
    items: ['Gramática visual del LSA explicada sin tecnicismos', 'Clasificadores: cómo describir objetos y movimientos', 'Estructura de oraciones en LSA vs. español', 'Cultura Sorda argentina: historia, identidad y comunidad', 'Variaciones regionales: Buenos Aires, Córdoba, Rosario y más']
  }, {
    num: 'Tomo 6',
    title: 'Situaciones Reales',
    icon: '💬',
    quote: 'El LSA en acción: conversaciones completas para la vida real.',
    items: ['Diálogos modelo para 10 situaciones frecuentes', 'Cómo manejar malentendidos y pedir que repitan', 'Señas para urgencias y situaciones de emergencia', 'Cómo presentarse como oyente que aprende LSA', 'Errores avanzados y cómo corregirlos']
  }, {
    num: 'Tomo 7',
    title: 'Maestría y Diccionario Visual',
    icon: '⭐',
    quote: 'El cierre del sistema: de bueno a fluido.',
    items: ['Diccionario visual de 500+ señas organizadas por categoría', 'Señas compuestas y expresiones idiomáticas del LSA', 'Narrativa en LSA: cómo contar una historia completa', 'El señante consciente: postura, fluidez y presencia', 'Tu hoja de ruta hacia la fluidez real']
  }];
  const includes = ['Descripción técnica de cada seña', 'Expresión facial y postura correcta', 'Frases con estructura real en LSA', 'Checklist de práctica y autoevaluación', '100% LSA argentino 2026'];
  return <section id="tomos" className="bg-lsa-dark text-white py-16 px-5" data-id="element-280">
      <div className="max-w-xl mx-auto" data-id="element-281">
        <div className="flex justify-center mb-6" data-id="element-282">
          <div className="bg-white/10 border border-white/20 rounded-full px-4 py-1.5 text-xs font-semibold tracking-wide flex items-center gap-2" data-id="element-283">
            <span data-id="element-284">📦</span> Sistema Completo
          </div>
        </div>

        <h2 className="text-[28px] font-bold text-center mb-3 leading-tight" data-id="element-285">
          7 tomos. +2000 señas. Todo resuelto.
        </h2>
        <p className="text-center text-white/80 text-[16px] mb-10" data-id="element-286">
          Del cero absoluto a la conversación real.
        </p>

        <div className="mb-10" data-id="element-287">
          {tomos.map((tomo, index) => <Accordion key={index} theme="dark" isOpen={openIndex === index} onToggle={() => setOpenIndex(openIndex === index ? -1 : index)} title={<div className="flex items-center gap-3" data-id="element-289">
                  <span className="text-lsa-celeste font-bold text-[13px] uppercase tracking-wide shrink-0" data-id="element-290">
                    {tomo.num}
                  </span>
                  <span className="text-xl" data-id="element-291">{tomo.icon}</span>
                  <span data-id="element-292">{tomo.title}</span>
                </div>} data-id="element-288">
              <div className="pt-2 pb-1" data-id="element-293">
                <p className="italic text-white/70 text-[14px] mb-4 border-l-2 border-lsa-celeste pl-3" data-id="element-294">
                  "{tomo.quote}"
                </p>
                <ul className="space-y-3" data-id="element-295">
                  {tomo.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-[14px] text-white/90" data-id="element-296">
                      <Check className="text-lsa-celeste shrink-0 mt-0.5" size={16} data-id="element-297" />
                      <span data-id="element-298">{item}</span>
                    </li>)}
                </ul>
              </div>
            </Accordion>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white/5 border border-white/10 rounded-2xl p-6" data-id="element-299">
          <h3 className="font-bold text-[16px] mb-4 text-lsa-celeste" data-id="element-300">
            Cada tomo incluye:
          </h3>
          <ul className="grid grid-cols-1 gap-3" data-id="element-301">
            {includes.map((item, i) => <li key={i} className="flex items-center gap-2 text-[14px] text-white/90" data-id="element-302">
                <Check className="text-lsa-celeste shrink-0" size={18} data-id="element-303" />
                <span data-id="element-304">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}